__turbopack_context__.v({
  "animated-download-svg": "download-module__lnEDnW__animated-download-svg",
  "arrow-pulse": "download-module__lnEDnW__arrow-pulse",
});
